// extracted by mini-css-extract-plugin
export default {"topSection":"program-side-panel_topSection__pcurG","title":"program-side-panel_title__0583L","row":"program-side-panel_row__zz+Cf","label":"program-side-panel_label__yCni3"};